import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const ProductionFloorWidget = ({
  width = 148,
  height = 167,
  color,
  iconColor,
  ...rest
}: {
  width: number;
  height: number;
  color: string;
  iconColor?: string;
  [x: string]: unknown;
}) => {
  const { token } = useToken() as unknown as CustomThemeToken;
  const currentColor = color ?? token.colorBgContainer;
  const currentIconColor = iconColor ?? token.colorPrimary;

  return (
    <svg width={width} height={height} viewBox="0 0 148 167" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M5 88.5H3C1.89543 88.5 1 87.6046 1 86.5L1 78.5C1 77.3954 1.89543 76.5 3 76.5H5L5 88.5Z"
        fill={token.colorBorder}
      />
      <g filter="url(#filter0_ddd_24572_1136)">
        <path
          d="M54.8041 21.4839L54.866 21.5H54.93H58.5922H59.0922V21V10.379C59.0922 9.85189 59.2526 9.42115 59.4609 9.15974C59.6669 8.9012 59.8718 8.84984 60.0363 8.89265L108.396 21.4839L108.458 21.5H108.522H111.171H111.615L111.668 21.0588L113.513 5.47271C113.674 4.75657 114.066 4.5 114.296 4.5H135.53C135.759 4.5 136.151 4.75655 136.312 5.47265L138.158 21.0588L138.21 21.5H138.654H142.5V68.5H5.5V10.379C5.5 9.85189 5.66037 9.42115 5.86868 9.15974C6.0747 8.9012 6.2796 8.84984 6.44404 8.89265L54.8041 21.4839Z"
          fill={currentColor}
          stroke={currentColor}
        />
        <rect width="138" height="56" transform="translate(5 20)" fill={currentColor} />
        <mask id="path-4-inside-1_24572_1136" fill="white">
          <path d="M92 36C92 33.7909 93.7909 32 96 32H108V52H96C93.7909 52 92 50.2091 92 48V36Z" />
        </mask>
        <path
          d="M92 36C92 33.7909 93.7909 32 96 32H108V52H96C93.7909 52 92 50.2091 92 48V36Z"
          fill={currentIconColor}
          opacity={currentIconColor ? '0.2' : 1}
        />
        <path
          d="M91 36C91 33.2386 93.2386 31 96 31H108V33H96C94.3431 33 93 34.3431 93 36H91ZM108 53H96C93.2386 53 91 50.7614 91 48H93C93 49.6569 94.3431 51 96 51H108V53ZM96 53C93.2386 53 91 50.7614 91 48V36C91 33.2386 93.2386 31 96 31V33C94.3431 33 93 34.3431 93 36V48C93 49.6569 94.3431 51 96 51V53ZM108 32V52V32Z"
          fill={currentIconColor}
          mask="url(#path-4-inside-1_24572_1136)"
        />
        <rect x="108" y="32" width="1" height="20" fill={currentIconColor} />
        <mask id="path-7-inside-2_24572_1136" fill="white">
          <path d="M109 32H121C123.209 32 125 33.7909 125 36V48C125 50.2091 123.209 52 121 52H109V32Z" />
        </mask>
        <path
          d="M109 32H121C123.209 32 125 33.7909 125 36V48C125 50.2091 123.209 52 121 52H109V32Z"
          fill={currentIconColor}
          opacity={currentIconColor ? '0.2' : 1}
        />
        <path
          d="M109 31H121C123.761 31 126 33.2386 126 36H124C124 34.3431 122.657 33 121 33H109V31ZM126 48C126 50.7614 123.761 53 121 53H109V51H121C122.657 51 124 49.6569 124 48H126ZM109 52V32V52ZM121 31C123.761 31 126 33.2386 126 36V48C126 50.7614 123.761 53 121 53V51C122.657 51 124 49.6569 124 48V36C124 34.3431 122.657 33 121 33V31Z"
          fill={currentIconColor}
          mask="url(#path-7-inside-2_24572_1136)"
        />
        <rect width="138" height="85" transform="translate(5 76)" fill={currentColor} />
      </g>
      <defs>
        <filter
          id="filter0_ddd_24572_1136"
          x="0"
          y="0"
          width="148"
          height="167"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_24572_1136" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect2_dropShadow_24572_1136" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_24572_1136" result="effect2_dropShadow_24572_1136" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_24572_1136" result="effect3_dropShadow_24572_1136" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_24572_1136" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default ProductionFloorWidget;
